import { FetchApiError, instanceOfErrorResponse } from "@repo/api";
import { EnvironmentHelper } from "@repo/helpers";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { ms } from "humanize-ms";
import { type FC, type PropsWithChildren } from "react";
import { CustomApiError } from "../types/errors";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            throwOnError(error) {
                if (error instanceof FetchApiError) {
                    const errorResponse = error.errorResponse as object;
                    if (typeof errorResponse === "object" && instanceOfErrorResponse(errorResponse)) {
                        return errorResponse.code !== Number(CustomApiError.StarPensionCallFailed);
                    }
                }
                return true;
            },
            refetchOnWindowFocus: false,
            retryOnMount: false,
            gcTime: ms("1d"),
        },
    },
});

const persister = createAsyncStoragePersister({
    storage: EnvironmentHelper.isBrowser() ? window.localStorage : undefined,
});

const ReactQueryClientProvider: FC<PropsWithChildren> = ({ children }) => {
    return (
        <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
            {children}
        </PersistQueryClientProvider>
    );
};

export default ReactQueryClientProvider;
